var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchivebox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Broken/archivebox"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.30798 24.4097V19.2947M35.808 19.2947V35.3914C35.808 39.0581 34.8913 40.8914 30.308 40.8914H13.808C9.22465 40.8914 8.30798 39.0581 8.30798 35.3914V31.6697M18.7213 26.2266H25.3947M9.22465 4.22656H34.8913C38.558 4.22656 40.3913 6.0599 40.3913 9.72656V13.3932C40.3913 17.0599 38.558 18.8932 34.8913 18.8932H9.22465C5.55798 18.8932 3.72464 17.0599 3.72464 13.3932V9.72656C3.72464 6.0599 5.55798 4.22656 9.22465 4.22656Z",
    stroke: "currentColor",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivebox);
export default __webpack_public_path__ + "static/media/archivebox.3639bdf75b3eb02ad17b880baa5723cb.svg";
export { ForwardRef as ReactComponent };